import { BaseDto } from './base.dto'

export class SettingDto extends BaseDto {
  id:string
  key: string
  type: string
  value: any
  
  static create() {
    return new SettingDto()
  }
}

export class UpdateSettingDto {
  value: string
}

export class FindSettingDto {
  mallId: string
}

export class ScheduleMallExport extends BaseDto {
  id:string
  key: string
  type: string
  value: string | number | boolean
  
  static create() {
    return new ScheduleMallExport()
  }
}

export enum SettingKey {
  Email = 'Email',
  PhoneNumber = 'PhoneNumber',
  Location = 'Location',
  CustomerServiceNote = 'CustomerServiceNote',
  ShippingFee = 'ShippingFee',
  CategoryCacheDuration = 'CategoryCacheDuration',
  KhLocation = 'KhLocation',
  KhCustomerServiceNote = 'KhCustomerServiceNote',
  CutOffTimeMorning = 'CutOffTimeMorning',
  CutOffTimeAfternoon = 'CutOffTimeAfternoon',
  ResizeImageFactor = 'ResizeImageFactor',
  FooterBannerImage = 'FooterBannerImage',
  FooterMobileBannerImage = 'FooterMobileBannerImage',
  ContactUsIssueDetail = 'ContactUsIssueDetail',
  ContactUsIssueDetailKh = 'ContactUsIssueDetailKh',
  DisableExportProductReportButton = 'DisableExportProductReportButton'
}